@if ((parts$ | async); as parts) {
  <div style="padding:0 15px 0 15px; display:flex; flex-flow:column; gap:15px;">
    <form [formGroup]="selectedProductForm"></form>
    @for (part of parts; track part; let index = $index) {
      <div>
        @switch (part.qtyType) {
          @case ('assortie') {
            <app-random-item [selectedProductForm]="selectedProductForm" [part]="part"></app-random-item>
          }
          @case ('fixe') {
            <app-fixed-item [selectedProductForm]="selectedProductForm" [part]="part"></app-fixed-item>
          }
          @case ('specific') {
            <app-specific-item [selectedProductForm]="selectedProductForm" [part]="part"></app-specific-item>
          }
        }
      </div>
    }
    <div>
      <button kendoButton
        class="cnp-button-primary"
        [disabled]="disableNextStep()"
        (click)="goToCompProductStep()">
        {{ 'btnNextStep' | translate }}
      </button>
    </div>
  </div>
}
